import { gql } from '@apollo/client';

export const GET_ALERTS_QUERY = gql`
  query GetAlerts($status: String, $limit: Int) {
    biasAlerts(status: $status, limit: $limit) {
      id
      severity
      status
      title
      message
      gracePeriodEnds
      dailyPenaltyApplied
      totalPenaltyApplied
      createdAt
      sentAt
      acknowledgedAt
      resolvedAt
      deletedAt
      biasScore
    }
  }
`;

export const ACKNOWLEDGE_ALERT_MUTATION = gql`
  mutation AcknowledgeAlert($input: BiasAlertAcknowledgeInput!) {
    acknowledgeBiasAlert(input: $input) {
      id
      status
      acknowledgedAt
    }
  }
`;

export const RESOLVE_ALERT_MUTATION = gql`
  mutation ResolveAlert($input: BiasAlertResolveInput!) {
    resolveBiasAlert(input: $input) {
      id
      status
      resolvedAt
      totalPenaltyApplied
    }
  }
`;

export const DELETE_ALERT_MUTATION = gql`
  mutation DeleteAlert($input: BiasAlertDeleteInput!) {
    deleteBiasAlert(input: $input)
  }
`;

